import React from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'keen-slider/keen-slider.min.css';

export default function CaseStudiesSection() {
    const caseStudiesData = [
        {
            id: 1,
            title: "US Midwest Community Bank Transforms Lending Operations Through Consulting-led Modernization",
            image: "/assets/insights/img4.jpg"
        },
        {
            id: 2,
            title: "Agentic AI Chatbot Enhancing Card Benefit Discovery and Utilization for a Global Payment Provider",
            image: "/assets/insights/img5.jpg"
        },
        {
            id: 3,
            title: "US Midwest Community Bank Transforms Lending Operations Through Consulting-led Modernization",
            image: "/assets/insights/img4.jpg"
        },
        {
            id: 4,
            title: "Agentic AI Chatbot Enhancing Card Benefit Discovery and Utilization for a Global Payment Provider",
            image: "/assets/insights/img5.jpg"
        },
    ];

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        loop: true,
        mode: "snap",
        slides: {
            perView: 1,
            spacing: 16,
        },
        breakpoints: {
            '(min-width: 768px)': {
                slides: { perView: 2, spacing: 24 },
            },
            '(min-width: 1024px)': {
                slides: { perView: 2, spacing: 32 },
            },
        },
    });

    return (
        <section className="bg-white pb-12 sm:pb-16 lg:pb-24 select-none text-left relative z-10 font-inter overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] w-full">

                <div className="mb-8 sm:mb-12 px-1 text-center">
                    <h2 className="text-[#01386A] font-sora font-[600] text-[20px] md:text-[30px] tracking-tight">
                        Case Studies
                    </h2>
                </div>

                <div className="w-full overflow-hidden">
                    <div ref={sliderRef} className="keen-slider">
                        {caseStudiesData.map((item) => (
                            <div key={item.id} className="keen-slider__slide">
                                <div className="w-full bg-white border border-[#01386A45] overflow-hidden group cursor-pointer relative flex flex-col justify-between transition-all duration-500 min-h-[420px] sm:min-h-[460px] lg:min-h-[520px]">
                                    <div className="w-full h-auto">
                                        <div className="w-full aspect-[16/9] overflow-hidden shrink-0 relative bg-gray-900">
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-104"
                                            />
                                            <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                                        </div>

                                        <div className="p-5 sm:p-8 lg:p-10 flex flex-col items-start space-y-6">
                                            <h3 className="text-[#01386A] font-sora font-[600] text-[16px] lg:text-[20px] leading-[1.4] tracking-tight transition-colors duration-300 line-clamp-3 md:line-clamp-4">
                                                {item.title}
                                            </h3>
                                        </div>
                                    </div>

                                    <div className="px-5 sm:px-8 lg:p-10 pb-6 sm:pb-8 lg:pb-12 pt-0 mt-auto">
                                        <a
                                            href="#"
                                            className="inline-flex items-center gap-1.5 text-[13px] sm:text-[14px] font-[600] text-[#01386A] border-b-2 border-[#01386A] pb-0.5 transition-all duration-300 group-hover:text-orange-500 group-hover:border-orange-500 group/link"
                                        >
                                            <span>Read More</span>
                                            <span className="transform transition-transform duration-300 group-hover/link:translate-x-1 text-orange-500 font-bold">
                                                &gt;
                                            </span>
                                        </a>
                                    </div>

                                    <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#2A4C55] z-20 overflow-hidden">
                                        <div className="absolute inset-0 bg-orange-500 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500 ease-out origin-left" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex items-center gap-3 mt-8 sm:mt-12 px-1">
                    <button
                        onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                        className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-orange-400 flex items-center justify-center text-orange-500 hover:bg-orange-50 active:scale-95 transition-all duration-200 cursor-pointer outline-none"
                    >
                        <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 stroke-[2.5]" />
                    </button>
                    <button
                        onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                        className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-orange-400 flex items-center justify-center text-orange-500 hover:bg-orange-50 active:scale-95 transition-all duration-200 cursor-pointer outline-none"
                    >
                        <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 stroke-[2.5]" />
                    </button>
                </div>

            </div>
        </section>
    );
}